import defaultWebShoppingCart from '#themes/default/web/pages/shoppingCart/shoppingCart.js';

import cButton from '#themes/avast/web/components/button/button.js';
import cButtons from '#themes/avast/web/components/buttons/buttons.js';
import cInfoBox from '#themes/avast/web/components/infoBox/infoBox.js';
import cLegalAgreementCheckbox from '#themes/avast/web/components/legalAgreementCheckbox/legalAgreementCheckbox.js';
import cPaymentSelection from '#themes/avast/web/components/paymentSelection/paymentSelection.js';

export default {
	middleware: defaultWebShoppingCart.middleware,
	components: {
		cButton,
		cButtons,
		cInfoBox,
		cLegalAgreementCheckbox,
		cPaymentSelection
	},
	extends: defaultWebShoppingCart
};
